export const ACTIONS = {
  ADDITIONAL_FILES_ADDED: 'ADDITIONAL_FILES_ADDED',
  ADDITIONAL_FILES_REMOVED: 'ADDITIONAL_FILES_REMOVED',
  CASES_SEARCH: 'CASES_SEARCH',
  CASE_ARCHIVED: 'CASE_ARCHIVED',
  CASE_CLAIMED: 'CASE_CLAIMED',
  CASE_CLINIC_REJECTION: 'CASE_CLINIC_REJECTION',
  CASE_CREATED_STANDALONE_APP: 'CASE_CREATED_STANDALONE_APP',
  CASE_DRAFT_DISCARDED: 'CASE_DRAFT_DISCARDED',
  CASE_DRAFT_SENT_FOR_REVIEW: 'CASE_DRAFT_SENT_FOR_REVIEW',
  CASE_DRAFT_UPLOADED: 'CASE_DRAFT_UPLOADED',
  CASE_DRAFT_UPLOAD_FAILED: 'CASE_DRAFT_UPLOAD_FAILED',
  CASE_FILE_ADDED: 'CASE_FILE_ADDED',
  CASE_IMAGES_UPLOADED: 'CASE_IMAGES_UPLOADED',
  CASE_RECORDER_STARTED: 'CASE_RECORDER_STARTED',
  CASE_REJECTED: 'CASE_REJECTED',
  CASE_REPORT_CREATED: 'CASE_REPORT_CREATED',
  CASE_REPORT_DISCARDED: 'CASE_REPORT_DISCARDED',
  CASE_REPORT_UPDATED: 'CASE_REPORT_UPDATED',
  CASE_REPORT_VIEWED: 'CASE_REPORT_VIEWED',
  CASE_REVIEW_CANCELED: 'CASE_REVIEW_CANCELED',
  CASE_REVIEW_DISCARDED: 'CASE_REVIEW_DISCARDED',
  CASE_REVIEW_REQUESTED: 'CASE_REVIEW_REQUESTED',
  CASE_REVIEW_STARTED: 'CASE_REVIEW_STARTED',
  CASE_REVIEW_UPLOADED: 'CASE_REVIEW_UPLOADED',
  CASE_REVIEW_UPLOAD_FAILED: 'CASE_REVIEW_UPLOAD_FAILED',
  CASE_SHARED_BYPASSED: 'CASE_SHARED_BYPASSED',
  CASE_SHARED_COMPLETED: 'CASE_SHARED_COMPLETED',
  CASE_SHARING_LINK_USED: 'CASE_SHARING_LINK_USED',
  CASE_SIGNED_OFF: 'CASE_SIGNED_OFF',
  CASE_SIGNED_OFF_FAILED: 'CASE_SIGNED_OFF_FAILED',
  CASE_SIGNED_OFF_UPLOADED: 'CASE_SIGNED_OFF_UPLOADED',
  CASE_UNARCHIVED: 'CASE_UNARCHIVED',
  CASE_UNCLAIMED: 'CASE_UNCLAIMED',
  CASE_UNSIGNED: 'CASE_UNSIGNED',
  CASE_VIEWED: 'CASE_VIEWED',
  CLINIC_PAYMENT: 'CLINIC_PAYMENT',
  CLINIC_PAYMENT_FAILED: 'CLINIC_PAYMENT_FAILED',
  CLINIC_UPLOAD: 'CLINIC_UPLOAD',
  CLINIC_UPLOAD_COMPLETED: 'CLINIC_UPLOAD_COMPLETED',
  CLINIC_UPLOAD_FAILED: 'CLINIC_UPLOAD_FAILED',
  COLLECTIONS_SEARCH: 'COLLECTIONS_SEARCH',
  COLLECTION_CREATED: 'COLLECTION_CREATED',
  COLLECTION_DELETED: 'COLLECTION_DELETED',
  COLLECTION_EDITED: 'COLLECTION_EDITED',
  COLLECTION_VIEWED: 'COLLECTION_VIEWED',
  CREATORS_VIEWED: 'CREATORS_VIEWED',
  CREATOR_INVITATION_RESEND: 'CREATOR_INVITATION_RESEND',
  CREATOR_INVITED: 'CREATOR_INVITED',
  CREATOR_REGISTRATION: 'CREATOR_REGISTRATION',
  DISCOUNTS_CREATED: 'DISCOUNTS_CREATED',
  DISCOUNTS_SEARCH: 'DISCOUNTS_SEARCH',
  DISCOUNTS_VIEWED: 'DISCOUNTS_VIEWED',
  DISCOUNT_DELETED: 'DISCOUNT_DELETED',
  DISCOUNT_EDITED: 'DISCOUNT_EDITED',
  FILE_DELETED: 'FILE_DELETED',
  FORGOT_PASSWORD_EMAIL: 'FORGOT_PASSWORD_EMAIL',
  INVITATION_ACCEPTED: 'INVITATION_ACCEPTED',
  INVITATION_RESEND: 'INVITATION_RESEND',
  LOGIN: 'LOGIN',
  LOGIN_ATTEMPT_FAILED: 'LOGIN_ATTEMPT_FAILED',
  ORDERS_SEARCH: 'ORDERS_SEARCH',
  ORDER_CHANGE_STATUS: 'ORDER_CHANGE_STATUS',
  PASSWORD_RESET: 'PASSWORD_RESET',
  PATIENTS_VIEWED: 'PATIENTS_VIEWED',
  PATIENT_CREATED: 'PATIENT_CREATED',
  PATIENT_DELETED: 'PATIENT_DELETED',
  PATIENT_FILE_STORAGE: 'PATIENT_FILE_STORAGE',
  PATIENT_REPORT_REQUESTED: 'PATIENT_REPORT_REQUESTED',
  PATIENT_REPORT_UPLOAD_FAILED: 'PATIENT_REPORT_UPLOAD_FAILED',
  PATIENT_REVIEW: 'PATIENT_REVIEW',
  PAYMENT_FAILED: 'PAYMENT_FAILED',
  PAYMENT_SUCCEDED: 'PAYMENT_SUCCEDED',
  RECORDER_DOWNLOADED: 'RECORDER_DOWNLOADED',
  RECORDER_LAUNCHED: 'RECORDER_LAUNCHED',
  REGISTRATION: 'REGISTRATION',
  RESEND_PATIENT_INVITE: 'RESEND_PATIENT_INVITE',
  RESOURCES_SEARCH: 'RESOURCES_SEARCH',
  RESOURCE_ADDED: 'RESOURCE_ADDED',
  RESOURCE_ADDITION_FAILED: 'RESOURCE_ADDITION_FAILED',
  RESOURCE_DELETED: 'RESOURCE_DELETED',
  RESOURCE_EDITED: 'RESOURCE_EDITED',
  RESOURCE_RECORDED: 'RESOURCE_RECORDED',
  RESOURCE_RECORDER_OPENED: 'RESOURCE_RECORDER_OPENED',
  USERS_VIEWED: 'USERS_VIEWED',
  USER_INVITED: 'USER_INVITED',
  VIEW_HELP_MATERIAL: 'VIEW_HELP_MATERIAL',
  VOICE_TRANSCRIPTION: 'VOICE_TRANSCRIPTION',
  WORKSPACE_ADD_EMAIL: 'WORKSPACE_ADD_EMAIL',
  WORKSPACE_BLOCK_ADMIN: 'WORKSPACE_BLOCK_ADMIN',
  WORKSPACE_CREATED: 'WORKSPACE_CREATED',
  WORKSPACE_EDIT: 'WORKSPACE_EDIT',
  WORKSPACE_INVITE_ADMIN: 'WORKSPACE_INVITE_ADMIN',
  WORKSPACE_REMOVE_EMAIL: 'WORKSPACE_REMOVE_EMAIL',
  WORKSPACE_SEARCH: 'WORKSPACE_SEARCH',
  WORKSPACE_UNBLOCK_ADMIN: 'WORKSPACE_UNBLOCK_ADMIN',
  WORKSPACE_VIEW: 'WORKSPACE_VIEW',
};

export const ROLES = {
  ADMIN: 'ADMIN',
  CREATOR: 'CREATOR',
  PATIENT: 'PATIENT',
  SUPER_ADMIN: 'SUPER_ADMIN',
  TRAINEE: 'TRAINEE',
};

export default {
  ACTIONS,
};
